/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LoafersInputs */

const en_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loafers`)
};

const es_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mocasines`)
};

const fr_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mocassins`)
};

const de_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loafer`)
};

const ja_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローファー`)
};

const zh_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乐福鞋`)
};

const ar_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحذية لوفر`)
};

const id_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loafers`)
};

const it_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mocassini`)
};

const ru_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лоферы`)
};

const pt_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mocassins`)
};

const ko_val_loafers = /** @type {(inputs: Val_LoafersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로퍼`)
};

/**
* | output |
* | --- |
* | "Loafers" |
*
* @param {Val_LoafersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_loafers = /** @type {((inputs?: Val_LoafersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LoafersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_loafers(inputs)
	if (locale === "es") return es_val_loafers(inputs)
	if (locale === "fr") return fr_val_loafers(inputs)
	if (locale === "de") return de_val_loafers(inputs)
	if (locale === "ja") return ja_val_loafers(inputs)
	if (locale === "zh") return zh_val_loafers(inputs)
	if (locale === "ar") return ar_val_loafers(inputs)
	if (locale === "id") return id_val_loafers(inputs)
	if (locale === "it") return it_val_loafers(inputs)
	if (locale === "ru") return ru_val_loafers(inputs)
	if (locale === "pt") return pt_val_loafers(inputs)
	return ko_val_loafers(inputs)
});